export class AnimationNodeContent {
}
